import { createColumnStmtInstruction } from './CreateColumnStmt';
import { createStructureFieldStmtInstruction } from './CreateFieldStmt';
import { removeStructureColumnStmtInstruction } from './RemoveColumnStmt';
import { removeFieldStmtInstruction } from './RemoveFieldStmt';
import { sortColumnsStmtInstruction } from './SortColumnsStmt';
export const elementInstruction = `
## Fields and Columns
Types: text, number, date, dateTime, select, multiselect, repeater, radio, checkbox, file, image, video, audio, content

- \`multiselect\` or \`repeater\` is used for ManyHasMany or OneHasMany relations. When specifying these fields, focus on the relation itself rather than individual properties within the related entity unless explicitly mentioned.
- \`select\` is used for ManyHasOne or OneHasOne relations. Emphasize the entity relationship without defaulting to specific properties unless required by the user.
- \`select\` or \`radio\` is used for Enum values, allowing users to choose from a predefined list.
- \`text\` or \`richText\` is used for String values, providing a field for textual input.
- \`checkbox\` is used for Bool values, offering a binary choice.
- \`number\` is used for Integer values, allowing numerical input.
- \`date\` or \`dateTime\` is used for DateTime or Date values, facilitating date and time selection.

### Field Instructions
${createStructureFieldStmtInstruction}
${removeFieldStmtInstruction}

### Column Instructions
${createColumnStmtInstruction}
${sortColumnsStmtInstruction}
${removeStructureColumnStmtInstruction}
`;
//# sourceMappingURL=elementInstruction.js.map